import { forwardRef } from 'react'
import { styled } from '@mui/material/styles'
import { isNilOrEmpty } from 'packages/core'
import classNames from 'classnames'
import { Box } from '@mui/material'

export interface IAttributeValueProps {
    className?: string
    children?: any
    sx?: object
}

// TODO: Will remove this once we start sending sx instead of classname for all pages
const AttributeValueBox = styled(Box)(({ theme }) => ({
    fontSize: '1.4rem',
    lineHeight: 1.33,
    color: theme.palette.common.black,
    width: '100%',
    display: 'block',
    wordBreak: 'break-word',
    wordWrap: 'break-word',
    paddingTop: '0.5rem',
    letterSpacing: '0.048rem',
}))

export const AttributeValue = forwardRef<any, IAttributeValueProps>(
    (props, ref) => {
        return (
            <AttributeValueBox
                className={classNames(props.className)}
                ref={ref}
                sx={{
                    ...(props.sx && props.sx),
                }}
            >
                {isNilOrEmpty(props.children) ? '-' : props.children}
            </AttributeValueBox>
        )
    },
)
